import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

const styles: StyleRulesCallback = theme => ({
  container: {
    marginRight: `${theme.spacing.unit}px`,
    textAlign: "right"
  }
});

const BaseContainer: React.FC<WithStyles<typeof styles>> = ({ classes, children }) => (
  <div className={classes.container}>{children}</div>
);

export const IconContainer = withStyles(styles)(BaseContainer);
